import React from 'react'
import Theme from '../theme/Theme' 
export const Text = (props) => {  
  return (
    <div  onClick={(e)=>{
      e.preventDefault(); 
    }} style={{...Theme()?.text,...props?.style}}>{props.data}{props?.children}</div>
  )
}
export default Text